import { Button, Tab, Tabs, Typography, Box } from '@mui/material';
import Alert from '@mui/material/Alert';
import { exportStrategyToCSV } from '../StrategyUtils';
import { PhaseAndStatusBadge } from './PhaseAndStatusBadge';
import dayjs from 'dayjs';
import { PageHeader } from '@deere/fuel-react/PageHeader.js';
import { PageHeaderTitle } from '@deere/fuel-react/PageHeaderTitle.js';
import { PageHeaderActions } from '@deere/fuel-react/PageHeaderActions.js';
import { useSelector } from 'react-redux';
import MessageBanner from '../../shared/MessageBanner';
import { SepPlansReviewMessage } from '../SepPlans/SepPlansReviewMessage';
import { PHASES, SEP_PLANS, TEMPLATES } from '../../shared/AppConstants';

export const StrategyHeader = ({
  isEdit,
  strategyInformation,
  deleteStrategy,
  cancelStrategy,
  hasUSScope,
  userInfoMap,
  allMGCSpend,
  paintSaveButton,
  lastUpdatedBy,
  strategyId,
  strategicSupplierDataGridApiRef,
  nonStrategicSupplierDataGridApiRef,
  onTabChange,
  statusMessages,
  apiInProgressCount,
  sepPlansToReview
}) => {
  const activeTab = useSelector((state) => state.strategy.activeTab);

  return (
    <PageHeader>
      <PageHeaderTitle>
        <Box
          sx={(theme) => ({
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: theme.fuel6Tokens.JddcSpacingMedium
          })}
        >
          <Typography variant="h1">
            {strategyId > 0
              ? `Maintain Strategy #${strategyId}`
              : 'Create Strategy'}
          </Typography>
          {strategyId > 0 && strategyInformation && (
            <PhaseAndStatusBadge strategy={strategyInformation} />
          )}
        </Box>
        {strategyId > 0 && strategyInformation && (
          <Typography color="textSecondary">
            Last updated on{' '}
            {dayjs(strategyInformation.updatedOn).format('DD-MMM-YYYY')} by{' '}
            {lastUpdatedBy}
          </Typography>
        )}
      </PageHeaderTitle>
      <PageHeaderActions>
        {isEdit && strategyInformation && (
          <Button
            variant="tertiary"
            startIcon={<fuel-icon name="delete" />}
            onClick={deleteStrategy}
          >
            Delete
          </Button>
        )}
        {isEdit && strategyInformation && (
          <Button
            variant="tertiary"
            startIcon={<fuel-icon name="download" />}
            onClick={(e) =>
              exportStrategyToCSV(
                e,
                strategyInformation,
                hasUSScope,
                userInfoMap,
                allMGCSpend,
                strategicSupplierDataGridApiRef,
                nonStrategicSupplierDataGridApiRef
              )
            }
          >
            Download XLSX
          </Button>
        )}
        <Button variant="secondary" onClick={cancelStrategy}>
          Cancel
        </Button>
        {paintSaveButton(strategyId)}
      </PageHeaderActions>
      <Box sx={{ gridArea: 'tabs' }}>
        {sepPlansToReview && sepPlansToReview.length > 0 && (
          <Alert
            severity="informational"
            sx={(theme) => ({ mt: theme.fuel6Tokens.JddcSpacingMedium })}
          >
            <SepPlansReviewMessage sepPlansToReview={sepPlansToReview} />
          </Alert>
        )}
        <MessageBanner
          statusMessages={statusMessages}
          apiInProgressCount={apiInProgressCount}
        />
        <Tabs
          value={activeTab}
          onChange={onTabChange}
          aria-label="strategy tabs"
        >
          <Tab id="strategy-tab-0" label="Strategy Info" />
          <Tab id="strategy-tab-1" label={SEP_PLANS} />
          <Tab id="strategy-tab-2" label={PHASES} />
          <Tab id="strategy-tab-3" label={TEMPLATES} />
        </Tabs>
      </Box>
    </PageHeader>
  );
};
